var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurnstilesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.333 28.333v-13.06c0-.442-.176-.865-.488-1.178l-3.607-3.607A1.667 1.667 0 0023.06 10h-9.727a1.666 1.666 0 00-1.667 1.667v16.666A1.666 1.666 0 0013.333 30h13.333a1.666 1.666 0 001.667-1.667zm-13.175-1.991a.54.54 0 01-.158-.383v-3.783a.54.54 0 01.923-.382l1.318 1.318a.133.133 0 00.096.04.135.135 0 00.095-.04l4.18-4.177a.134.134 0 00.03-.147.133.133 0 00-.03-.044l-1.318-1.321a.54.54 0 01.382-.923h3.784a.54.54 0 01.54.54v3.784a.54.54 0 01-.923.382l-1.318-1.318a.133.133 0 00-.096-.04.136.136 0 00-.095.04l-4.18 4.178a.134.134 0 000 .191l1.318 1.32a.54.54 0 01-.382.923H15.54a.54.54 0 01-.382-.158z",
    fill: "#0F0449"
  })));
}

export default SvgTurnstilesinline;